import React, { Component } from 'react';

class ErrorDisplay extends Component {

  constructor(props) {
    super(props)
    this.focusRef = React.createRef();
  }

  componentDidMount(){
    this.focusRef.current.focus();
  }

  render() {
    const { heading } = this.props;
    const errorArray = this.props.errors.map(error => {
      return <li key={error}>{error}</li>;
    });
    return (
      <div ref={this.focusRef} className={this.props.className} tabIndex='0'>
        { heading && <strong>{heading}</strong> }
        <ul>{errorArray}</ul>
      </div>
    )
  }
}

export default ErrorDisplay;
